document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('.article-template');
  if (!container) return;

  const section1 = document.querySelector('.related_products');
  const section2 = document.querySelector('.related_products_2');

  function replacePlaceholder(placeholder, section) {
    if (!section) return;
    section.style.display = '';

    const searchText = `[${placeholder}]`;
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const idx = node.textContent.indexOf(searchText);
      if (idx !== -1) {
        const range = document.createRange();
        range.setStart(node, idx);
        range.setEnd(node, idx + searchText.length);
        range.deleteContents();
        range.insertNode(section);
        break;
      }
    }
  }

  replacePlaceholder('Related products 1', section1);
  replacePlaceholder('Related products 2', section2);

  document.querySelectorAll('.blog-content .table').forEach((table) => {
    if (table.parentNode.classList.contains('table-wrapper')) return;
    const wrapper = document.createElement('div');
    wrapper.classList.add('table-wrapper');
    wrapper.style.overflowX = 'auto';
    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  });
});
